import React from 'react'

import { useImperativeInterval } from './useImperativeInterval'

export function useInterval<T extends () => unknown>(
  callback: T,
  duration: number | null
): { set: (duration?: number) => void; clear: () => void | undefined } {
  const handle = useImperativeInterval(callback, duration || 0)
  React.useEffect(() => {
    if (duration != null) {
      handle.set()
      return handle.clear
    }
  }, [duration, handle])
  return handle
}
